import { signInWithRedirect } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';
import { useState } from 'react';
import { SQUARE_IDENTITY_PROVIDER_NAME } from '../config';
import { clearDevSession } from '../core/devAuth';

/**
 * Whether signing in with Square came back failed: the seller said no, or OrderHub couldn't sign
 * them up. Amplify finishes the redirect as soon as `configureAuth` runs, before any component can
 * listen, so this listens from import.
 */
let isSignInWithRedirectFailed = false;
Hub.listen('auth', ({ payload }) => {
  if (payload.event === 'signInWithRedirect_failure') isSignInWithRedirectFailed = true;
});
export const hasSignInWithRedirectFailed = () => isSignInWithRedirectFailed;

export const useSquareSignIn = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [userVisibleError, setUserVisibleError] = useState('');

  /**
   * Leaves for Square, through Cognito's hosted UI, and comes back signed in, or with
   * `hasSignInWithRedirectFailed()`. Needs `configureAuth`'s `oauth`.
   */
  const signInWithSquare = async () => {
    clearDevSession();
    setUserVisibleError('');
    setIsLoading(true);
    try {
      await signInWithRedirect({ provider: { custom: SQUARE_IDENTITY_PROVIDER_NAME } });
    } catch (error: unknown) {
      console.error('signInWithSquare error:', error);
      setUserVisibleError(error instanceof Error ? error.message : String(error));
      setIsLoading(false);
    }
  };

  return { isLoading, userVisibleError, signInWithSquare };
};
